<template>
  <div>
<!--    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>-->
    <!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>功能</th>
        <th>類型</th>
        <th>名稱</th>
        <th>日期</th>
        <th>已報名人數</th>
        <th>報名人數上限</th>
        <th>狀態</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td width="200px">
          <a role="button" class="btn btn-primary" href="#" @click="gotoDetail(item.id)">名單</a>

          <span v-if="item.status==='expired'">
            <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>
          </span>
        </td>
        <td width="200px">
          {{item.group_name}}
        </td>
        <td width="220px">
          {{item.name}}
        </td>
        <td width="200px">
          <p style="font-size: 20px"><b>{{item.event_dt}}</b></p>
        </td>
        <td width="120px">
          {{item.applicant_current}}
        </td>
        <td width="120px">
          {{item.applicant_limitText}}
        </td>
        <td>
          <div v-if="item.status==='open'">
              開放報名中
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,'close')">停止報名</a>
          </div>
          <div v-else-if="item.status==='close'">
              停止報名中
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'open')">開啟報名</a>
          </div>
          <div v-else-if="item.status==='expired'">
              已過期
          </div>
          <div v-else>

          </div>

        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGods from "@/views/fireGods/js/apiFireGods";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";

export default {
  components: {MyCkEditor},
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
    };
  },
  methods: {
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGods.api_Admin_EventItems_Query().then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    submit(){
      debugger // eslint-disable-line
      apiFireGods.api_Admin_EventDefine_Save(this.datas).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    gotoDetail(id){
      this.$router.push({ name: 'EventItemsDetail', query: { eventItem_id: id }})
    },
    deleteDetail(id){
      //confirm delete
      if(confirm('確定要刪除嗎?')){
        apiFireGods.api_Admin_EventItems_Delete(id).then(()=>{
          alert('刪除成功')
          this.loadData();
        })
      }

    },
    changeStatus(id,status){
      apiFireGods.api_Admin_EventItems_ChangeStaus(id,status).then((data)=>{
        console.log(data);
        alert('儲存成功')
        this.loadData();
      })
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1200px;
}
.btn{
  color: white !important;
  margin: 5px;
  /*width: 40px;*/
}
</style>
